const _none = "none"
const _all = "all"
const _DEFAULT = "color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter"
const _colors = "color, background-color, border-color, text-decoration-color, fill, stroke"
const _opacity = "opacity"
const _shadow = "box-shadow"
const _transform = "transform"
const config = { "none": _none, "all": _all, "DEFAULT": _DEFAULT, "colors": _colors, "opacity": _opacity, "shadow": _shadow, "transform": _transform,  }
export { config as default, _none, _all, _DEFAULT, _colors, _opacity, _shadow, _transform }